import { browserConstants } from '../constants/actionTypes'
export const browser = (
  state = { outdatedBrowser: false, displayNotification: true },
  action = {}
) => {
  switch (action.type) {
    case browserConstants.SET_BROWSER:
      return {
        ...state,
        outdatedBrowser: action.payload,
      }
    case browserConstants.DISPLAY_NOTIFICATION:
      return {
        ...state,
        displayNotification: action.payload,
      }
    default:
      return state
  }
}
